const configuredUrl = (process.env.REACT_APP_API_BASE_URL || "https://manage.businesseventssarawak.com").replace(/\/+$/, "");

export const API_BASE_URL = configuredUrl.endsWith("/backend-api/v1")
  ? configuredUrl
  : `${configuredUrl}/backend-api/v1`;
